import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import '../App.css';

class Header extends Component {
  
    constructor(props) {
        super();
        this.props = props;
    }
  
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount(){

  }

  rerouteTo(URL) {
    // const navigate = useNavigate();
    // navigate('/home')
  }

  render () {
    

    return (
        
      <div className="header">
            <Link to="/" className="header-text">Brandon Falcone</Link>
            <div className="header-links">
              <Link to="/" className="header-link">Home</Link>
              <Link to="/portfolio" className="header-link">Work</Link>
              <Link to="/contact" className="header-link">Contact</Link>
            </div>
      </div>
    );
  }
}

export default Header;
